import { useState, useEffect } from 'react'

const NAMES = [
  'Carlos M.',
  'Laura G.',
  'David R.',
  'Ana P.',
  'Javier T.',
  'Elena S.',
  'Miguel A.',
  'Carmen L.',
  'Alejandro V.',
  'Sofía C.',
]

const CITIES = [
  'Madrid',
  'Barcelona',
  'Valencia',
  'Sevilla',
  'Bilbao',
  'Málaga',
  'Zaragoza',
  'Alicante',
  'Murcia',
]

interface SocialProofData {
  name: string
  city: string
  timeAgo: number
}

export function useSocialProof() {
  const [isVisible, setIsVisible] = useState(false)
  const [data, setData] = useState<SocialProofData | null>(null)

  useEffect(() => {
    const triggerPopup = () => {
      const randomName = NAMES[Math.floor(Math.random() * NAMES.length)]
      const randomCity = CITIES[Math.floor(Math.random() * CITIES.length)]
      const randomTime = Math.floor(Math.random() * 59) + 1

      setData({
        name: randomName,
        city: randomCity,
        timeAgo: randomTime,
      })

      setIsVisible(true)

      // Hide after 5 seconds
      setTimeout(() => {
        setIsVisible(false)
      }, 5000)
    }

    // Initial delay before first popup
    const initialTimeout = setTimeout(triggerPopup, 5000)

    // Then trigger every 12-20 seconds
    const interval = setInterval(
      () => {
        triggerPopup()
      },
      Math.floor(Math.random() * 8000) + 12000,
    )

    return () => {
      clearTimeout(initialTimeout)
      clearInterval(interval)
    }
  }, [])

  return { isVisible, data }
}
